import { render } from "./SwitchableText.vue?vue&type=template&id=44ac0cdc"
import script from "./SwitchableText.vue?vue&type=script&lang=js"
export * from "./SwitchableText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__